import Typography from 'components/Atoms/Typography';
import folderIcon from '../../../assets/images/Folder/folder.svg';
function FolderName({ handleFolderClick, folder }) {
  return (
    <div
      onClick={() => {
        handleFolderClick(folder);
      }}
      onKeyDown={() => {}}
      role="button"
      tabIndex="0"
    >
      <div className="ltw-flex ltw-items-center ltw-gap-8px ltw-pt-5px ltw-py-5px">
        <img src={folderIcon} width="16" height="16" alt="folder" />
        <Typography variant="h2" fontType="ltw-font-normal" cursor="pointer">
          {folder.name}
        </Typography>
      </div>
    </div>
  );
}
export default FolderName;
